<template>
  <div v-if="isShow" class="dialog-content">
    <div class="popup-mask"></div>
    <div v-rect-loading="loading" class="dialog-content">
      <div class="container-body">
        <div class="title-content">
          <slot name="title"></slot>
        </div>
        <div class="body-content">
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="!hideFooter" class="container-footer">
        <slot name="footer">
          <div class="dialog-footer">
            <el-button v-show="!hideCancelBtn" class="footer-btn cancel-btn" @click="onCancelBtnClick">{{ cancelBtnLabel || $t(cancelBtnLabelI18nKey || 'common.btn.cancel') }}</el-button>
            <el-button class="footer-btn save-btn" :disabled="disabledSaveBtn" @click="onSaveBtnClick">{{ saveBtnLabel || $t(saveBtnLabelI18nKey || 'common.btn.confirm') }}</el-button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hiddenLogo: {
      type: Boolean,
      default: false
    },
    logo: {
      type: String,
      default: ''
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideCancelBtn: {
      type: Boolean,
      default: false
    },
    cancelBtnLabel: {
      type: String,
      required: false
    },
    cancelBtnLabelI18nKey: {
      type: String,
      required: false
    },
    saveBtnLabel: {
      type: String,
      required: false
    },
    saveBtnLabelI18nKey: {
      type: String,
      required: false
    },
    disabledSaveBtn: {
      type: Boolean,
      default: false
    },
    closeOnSave: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onCancelBtnClick () {
      this.isShow = false
      this.$emit('cancel')
    },
    onSaveBtnClick () {
      if (this.closeOnSave) {
        this.isShow = false
      }
      this.$emit('save')
    }
  },
  watch: {
    isShow () {
      if (this.isShow) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  .popup-mask {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .75;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
  }
  .dialog-content {
    border-top: 14px solid var(--custom-color, #0096cc);
    width: 70%;
    padding: 20px;
    background: #fff;
    position: fixed;
    top: 20%;
    left: 10%;
    z-index: 10001;
    max-height: 70vh;
    max-height: 70dvh;
    .container-header {
      height: 10%;
      position: relative;
      margin-bottom: 26px;
      margin-top: 6px;
      .company-logo {
        height: 60px;
        width: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .container-body {
      margin-bottom: 10%;
      overflow: hidden;
      position: relative;
      min-height: 20vh;
      min-height: 20dvh;
      .title-content {
        font-weight: 700;
        font-size: 14px;
        text-align: center;
        line-height: normal;
        color: #333;
        margin-bottom: 20px;
        word-break: break-word;
      }

      .body-content {
        height: 100%;
        overflow: hidden auto;
        font-size: 14px;
        word-break: break-word;
        max-height: 30dvh;
        max-height: 30vh;
        color: #333;
      }
    }

    .container-footer {
      .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .footer-btn  {
          width: 120px;
          height: 30px;
          border-radius: 15px;
          margin: 0;
          padding: 0;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
        }

        .save-btn {
          margin-left: auto;
          background: var(--custom-color, #0096cc);
          color: #fff;
          border: 1px solid var(--custom-color, #0096cc);

          &:hover {
            background: var(--custom-color, #008fc3);
            border-color: var(--custom-color, #008fc3);
          }
        }

        .is-disabled {
          background: var(--custom-color, #0096cc);
          border-color: var(--custom-color, #0096cc);

          &:hover {
            background: var(--custom-color, #0096cc);
            border-color: var(--custom-color, #0096cc);
          }
        }

        .cancel-btn {
          background: #a9a9a9;
          color: #fff;
          border: 1px solid #a9a9a9;
        }
      }
    }
  }
}
</style>
